import React, { Component } from 'react';
import TreeView from './TreeView.js';
import { Formik } from 'formik';
import { Form, Field, Textarea } from '../Form/Form.js';
import LocationModal from './LocationModal.js';
import DeleteButton from './../common/DeleteButton';
import DynamicForm from './DynamicForm.js';
import * as Yup from 'yup';

class SiteEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sites: [],
      loading: true,
      initialValues: {
        entryType: "ou",
        dnPrefix: "",
        contactName: "",
        contactEmail: "",
        contactNumber: "",
        address: "",
        url: "",
        notice: "",
        currentPassword: "",
        ldap: true,
      }
    }
  }

  componentDidMount = () => {
    this.getSites();
  }

  getSites = () => {
    fetch('/api/getAvailableSites', {
      method: "GET",
      credentials: "same-origin"
    }).then(r =>  r.json().then(data => ({res: r, body: data})))
    .then(obj => {
      if(!obj.res.ok) throw Error(obj.res.statusText);
      else{
        if(obj.body === undefined || obj.body === null) console.log("No Resources to display");
        else{
          this.setState({sites: this.buildTree(obj.body)});
        }
      }

    }).then(() => {
      console.log("Finished loading sites");
    })
    .catch(function(error) {
      console.log(error);
    })
    .then(() => this.setState({loading: false}));
  }

  buildTree = (resourceList) => {
    let tree = []
    let dict = {}
    resourceList.forEach((resource) => {
      let curTree = tree;
      let curDict = dict;
      let parent = null;
      resource.dn.forEach((nodeName, i) => {
        if (!curDict[nodeName]) {
          curDict[nodeName] = {index: curTree.length, children: {}};
          curTree.push({});
        }
        curTree = curTree[curDict[nodeName].index];
        curDict = curDict[nodeName].children;

        if (i === resource.dn.length - 1) {
          curTree.name = nodeName;
          curTree.type = resource.type;
          curTree.selectable = true;
          curTree.parent = parent;

          curTree.initialValues = {}
          curTree.initialValues.url = resource.url || "";
          curTree.initialValues.contactNumber = resource.phone || "";
          curTree.initialValues.contactEmail = resource.email || "";
          curTree.initialValues.contactName = resource.name || "";
          curTree.initialValues.address = resource.address || "";
          curTree.initialValues.notice = resource.notice || "";
          curTree.initialValues.ldap = resource.ldap === undefined || resource.ldap === null ? true : resource.ldap;
        } else {
          if (!curTree.children)
            curTree.children = [];
          parent = curTree;
          curTree = curTree.children;
        }
      });
    });

    return tree;
  }

  deleteSite = ({ values, setFieldTouched, setErrors, setFieldValue }) => {
    if (!values.currentPassword || values.currentPassword === "") {
      return setFieldTouched("currentPassword", true);
    }

    this.setState({ loading: true });
    fetch(
      '/api/deleteSite',
      {
        method: "POST",
        body: JSON.stringify(values),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      },
    )
    .then((res) => {
      if (!res.ok) {
        if (res.status === 401) {
          alert("Incorrect Password");
        } else if (res.status === 400) {
          res.json().then(errors => setErrors(errors));
        } else {
          alert("An error occured");
          throw Error(res.statusText);
        }
      } else {
        alert("Site deleted!");
        this.props.cancel();
      }
    })
    .catch(error => console.log(error))
    .then(() => {
      this.setState({loading: false});
      setFieldValue('currentPassword', '', false);
    });
  }

  submit = (values, actions) => {
    fetch('/api/editSite', {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    })
    .then((res) => {
      if(!res.ok){
        if(res.status === 401) alert("Incorrect Password")
        else {
          alert("Could not edit site");
          throw Error(res.statusText);
        }
      } else {
        alert("Site successfully updated!");
        this.props.cancel();
      }
    }).catch(function(error) {
      console.log(error);
    })
    .then(() => actions.setSubmitting(false));
  }

  validationSchema = () => {
    return Yup.object()
      .shape({
        entryType: Yup.string().ensure(),
        contactEmail: Yup.string()
          .when('entryType', {
            is: (entryType) => entryType !== "dc",
            then: Yup.string().ensure().email("Please enter a valid email!"),
            otherwise: null
          }),
        url: Yup.string()
          .when('entryType', {
            is: (entryType) => entryType === "dc",
            then: Yup.string().ensure().required("Required!").url("Invalid url!"),
            otherwise: null
          }),
        currentPassword: Yup.string().ensure()
          .required('Required!')
      });
  }

  render() {
    return (
      <Formik initialValues={this.state.initialValues} onSubmit={this.submit} validationSchema={this.validationSchema()}>
      {
        (props) => {
          let updateForm = (node) => {
            props.setFieldValue("entryType", node.type, false);

            let dnPrefix = "";
            let currentNode = node;
            while (currentNode && currentNode !== this.state.sites) {
              dnPrefix += `${currentNode.type}=${currentNode.name}, `;
              currentNode = currentNode.parent;
            }
            let initialValues = this.state.initialValues;
            for (let key in node.initialValues) {
              initialValues[key] = node.initialValues[key];
              props.setFieldValue(key, node.initialValues[key], false);
            }
            initialValues.entryType = node.type;
            initialValues.dnPrefix = dnPrefix;
            props.setFieldValue("dnPrefix", dnPrefix, false);
          }

          return (
            <Form title="Edit Site" onSubmit={props.handleSubmit} isLoading={props.isSubmitting || this.state.loading}>
              <div className="form-group">
                <label className="col-md-4 control-label"></label>
                <div className="col-md-8">
                  <LocationModal label={"Select Site To Edit"}>
                    <TreeView data={this.state.sites} update={updateForm} {...props} />
                  </LocationModal>
                 </div>
              </div>    

              <hr style={{margin: "40px 0px", marginLeft: "20px"}} />

              {
                props.values.dnPrefix !== "" && 
                <div>
                  <div className="form-group">
                    <label className="col-md-4 control-label">DN</label>
                    <label className="col-md-8">
                      {`${props.values.dnPrefix} ou=Sites, dc=DirectControl`}
                    </label>
                  </div>

                  <DynamicForm type={props.values.entryType} {...props} />

                  <Textarea id="notice" fieldName="Notice" {...props} />

                  <div className="form-group">
                    <label className="col-md-4 control-label"></label>
                    <div className="col-md-4"></div>
                    <div className="col-md-4">
                      <button type="button" className="btn btn-default" onClick={() => props.setFieldValue('notice', '')} disabled={!props.values.notice}>
                        <span className="glyphicon glyphicon-erase"></span> Clear Notice
                      </button>
                    </div>
                  </div>

                  <hr style={{margin: "40px 0px 40px 20px"}} />

                  <DeleteButton onClick={() => this.deleteSite(props)} />

                  <hr style={{margin: "40px 0px", marginLeft: "20px"}} />

                  <Field id="currentPassword" fieldName="Current Password" type="password" {...props} />
                </div>
              }

              <div className="form-group">
                <label className="col-md-4 control-label"></label>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6"> 
                      <button type="submit" className="btn btn-primary" disabled={!props.dirty}>Save Changes</button>
                    </div>
                    <div className="col-md-6">
                      <button type="button" className="btn btn-light" onClick={this.props.cancel}>Cancel</button>
                    </div>
                  </div>
                </div>
              </div>              
              {
                (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') && 
                <div>
                  <pre>
                    isDirty: {props.dirty.toString()}
                  </pre>
                  <pre>
                    {`${JSON.stringify(props.values, null, 2)}`}
                  </pre> 
                  <pre>
                    {"Initial Values:\n"}
                    {`${JSON.stringify(this.state.initialValues, null, 2)}\n`}
                  </pre>
                </div>
              }
            </Form>
          )
        }
      }
      </Formik>
    )
  }
}

export default SiteEdit;


// WEBPACK FOOTER //
// ./src/Components/SiteManagement/SiteEdit.js